export default {
  /*allCourseList: [],
  allPersonListForDuty: [],
  dailyProjectData: [],
  dailyProjectList: [],*/
};
